/* eslint-disable */
import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AcceptCancellationInput = {
  refundType: RefundType;
};

export type Account = {
  __typename?: 'Account';
  id: Scalars['ID'];
  type: Scalars['String'];
};

export type AddAdyenInput = {
  type: Scalars['String'];
  apiVersion: Scalars['String'];
  merchantId: Scalars['String'];
  cardType: Scalars['String'];
  holderName: Scalars['String'];
  encryptedCardNumber: Scalars['String'];
  encryptedExpiryMonth: Scalars['String'];
  encryptedExpiryYear: Scalars['String'];
  encryptedSecurityCode: Scalars['String'];
  tokenizedCreditCard: Scalars['String'];
};

export type AddCreditCardInput = {
  type: Scalars['String'];
  apiVersion: Scalars['String'];
  merchantId: Scalars['String'];
  cardType: Scalars['String'];
  sessionId?: Maybe<Scalars['String']>;
  expiryMonth?: Maybe<Scalars['String']>;
  expiryYear?: Maybe<Scalars['String']>;
  nameOnCard?: Maybe<Scalars['String']>;
  holderName?: Maybe<Scalars['String']>;
  encryptedCardNumber?: Maybe<Scalars['String']>;
  encryptedExpiryMonth?: Maybe<Scalars['String']>;
  encryptedExpiryYear?: Maybe<Scalars['String']>;
  encryptedSecurityCode?: Maybe<Scalars['String']>;
  tokenizedCreditCard?: Maybe<Scalars['String']>;
};

export type AddMastercardInput = {
  type: Scalars['String'];
  apiVersion: Scalars['String'];
  merchantId: Scalars['String'];
  cardType: Scalars['String'];
  sessionId: Scalars['String'];
  expiryMonth: Scalars['String'];
  expiryYear: Scalars['String'];
  nameOnCard: Scalars['String'];
};

export type AddPaymentMethod = {
  __typename?: 'AddPaymentMethod';
  id: Scalars['ID'];
  state: AddPaymentMethodState;
};

export type AddPaymentMethodState = 'ACCEPTING' | 'ACCEPTED' | 'FAILED';

export type Address = {
  __typename?: 'Address';
  streetAddress: Array<Scalars['String']>;
  suburb: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  country: Scalars['String'];
};

export type Amendment = {
  __typename?: 'Amendment';
  id: Scalars['ID'];
  state: AmendmentState;
  createdAt?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['String']>;
  cancellationPolicy?: Maybe<CancellationPolicy>;
  amendmentTotal?: Maybe<AmendmentTotal>;
  payableAtProperty?: Maybe<PayableAtProperty>;
  errors?: Maybe<Array<PlatformError>>;
};

export type AmendmentRequest = {
  __typename?: 'AmendmentRequest';
  bookingId: Scalars['ID'];
  caseNumber: Scalars['String'];
};

export type AmendmentState = 'QUOTING' | 'QUOTED' | 'ACCEPTING' | 'ACCEPTED' | 'FAILED' | 'BLOCKED' | 'INVALID';

export type AmendmentTotal = {
  __typename?: 'AmendmentTotal';
  type?: Maybe<AmendmentTotalType>;
  totals: Array<Total>;
  adjustment: Array<Total>;
  breakdown: Array<PaymentMethodBreakdown>;
};

export type AmendmentTotalType = 'NO_PAYMENT' | 'ADDITIONAL_PAYMENT' | 'REFUND_PAYMENT';

export type AvailabilityCalendar = {
  __typename?: 'AvailabilityCalendar';
  stays: Array<Maybe<AvailableStay>>;
};

export type AvailableStay = {
  __typename?: 'AvailableStay';
  checkIn: Scalars['String'];
  available: Scalars['Boolean'];
};

export type Booking = {
  __typename?: 'Booking';
  id: Scalars['ID'];
  state: BookingState;
  brand: Scalars['String'];
  channel: Scalars['String'];
  reference: Scalars['String'];
  createdAt: Scalars['String'];
  nights: Scalars['Int'];
  transactions: Array<Transaction>;
  paymentMethods: Array<PaymentMethod>;
  travelArranger: TravelArranger;
  account?: Maybe<Account>;
  reservation: Reservation;
  latestChange: Change;
  payableAtProperty?: Maybe<PayableAtProperty>;
  payableAtBooking: Total;
  payableTotals: Array<Total>;
  paymentSchedule: Array<ScheduledPayment>;
  links: BookingLinks;
  image: ImageAttributes;
  flags: BookingFlags;
  summaryText: Scalars['String'];
  paidBeforeCancellation: PaidBeforeCancellation;
  cancellationRefund?: Maybe<CancellationRefund>;
};

export type BookingImageArgs = {
  size?: Maybe<ImageSize>;
};

export type BookingAuthMethod = 'SSO' | 'SBA';

export type BookingFlags = {
  __typename?: 'BookingFlags';
  isFinalising: Scalars['Boolean'];
  isBooked: Scalars['Boolean'];
  isCancelled: Scalars['Boolean'];
  isBlocked: Scalars['Boolean'];
  isChangeInProgress: Scalars['Boolean'];
  isRateable: Scalars['Boolean'];
  isCancelable: Scalars['Boolean'];
  isCancelableInApp: Scalars['Boolean'];
  isCancelableByPhone: Scalars['Boolean'];
  isDateAmendableInApp: Scalars['Boolean'];
  isChangeDatesRequestEnabled: Scalars['Boolean'];
  isCreditCardExpired: Scalars['Boolean'];
  hasPendingScheduledPayment: Scalars['Boolean'];
  hasAppleWalletPass: Scalars['Boolean'];
  requiresPaymentMethodUpdate: Scalars['Boolean'];
};

export type BookingLinks = {
  __typename?: 'BookingLinks';
  manage: Scalars['String'];
  rebook: Scalars['String'];
  updatePaymentMethod: Scalars['String'];
  print: Scalars['String'];
  googleMaps: Scalars['String'];
  downloadInvoice: Scalars['String'];
  downloadAppleWalletPass: Scalars['String'];
};

export type BookingLinksManageArgs = {
  absolute?: Maybe<Scalars['Boolean']>;
};

export type BookingLinksRebookArgs = {
  absolute?: Maybe<Scalars['Boolean']>;
};

export type BookingLinksUpdatePaymentMethodArgs = {
  absolute?: Maybe<Scalars['Boolean']>;
};

export type BookingLinksPrintArgs = {
  absolute?: Maybe<Scalars['Boolean']>;
};

export type BookingList = {
  __typename?: 'BookingList';
  bookings: Array<Booking>;
  hasMore: Scalars['Boolean'];
};

export type BookingListFilter = 'UPCOMING' | 'COMPLETED' | 'CANCELLED';

export type BookingPaymentMethod =
  | CreditCardPaymentMethod
  | PointsPaymentMethod
  | VoucherPaymentMethod
  | CreditNotePaymentMethod
  | QantasGroupCreditVoucherPaymentMethod;

export type BookingState = 'BOOKING' | 'BOOKED' | 'CANCELLED' | 'FAILED' | 'BLOCKED';

export type Cancellation = {
  __typename?: 'Cancellation';
  id: Scalars['ID'];
  state: CancellationState;
  createdAt?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['String']>;
  refund?: Maybe<CancellationRefund>;
  creditNote?: Maybe<CreditNoteSummary>;
  isCreditCardExpired?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<PlatformError>>;
};

export type CancellationPolicy = {
  __typename?: 'CancellationPolicy';
  description: Scalars['String'];
  cancelTime: Scalars['String'];
  cancelTimeTimezone: Scalars['String'];
  cancellationWindows: Array<CancellationWindow>;
  activeCancellationWindow?: Maybe<CancellationWindow>;
};

export type CancellationRefund = {
  __typename?: 'CancellationRefund';
  totals: Array<Total>;
  breakdown: Array<PaymentMethodBreakdown>;
  penalty: Array<Total>;
  charges: Array<Total>;
};

export type CancellationState = 'QUOTING' | 'QUOTED' | 'ACCEPTING' | 'ACCEPTED' | 'FAILED' | 'BLOCKED' | 'INVALID';

export type CancellationWindow = {
  __typename?: 'CancellationWindow';
  cancellationType: CancellationWindowType;
  startTime: Scalars['String'];
  endTime: Scalars['String'];
  isFullyRefundable: Scalars['Boolean'];
  isPartiallyRefundable: Scalars['Boolean'];
  isNonRefundable: Scalars['Boolean'];
};

export type CancellationWindowType = 'FULLY_REFUNDABLE' | 'PARTIALLY_REFUNDABLE' | 'NON_REFUNDABLE';

export type Change = {
  __typename?: 'Change';
  id: Scalars['ID'];
  createdAt: Scalars['String'];
  completedAt: Scalars['String'];
  type: ChangeType;
  state: Scalars['String'];
  inProgress: Scalars['Boolean'];
};

export type ChangeType = 'CREATION' | 'AMENDMENT' | 'CANCELLATION';

export type ChargeBreakdown = {
  __typename?: 'ChargeBreakdown';
  creditCard: CreditCardPayment;
  points: PointsPayment;
  voucher: VoucherPayment;
  creditNote: CreditNotePayment;
  qantasGroupCreditVoucher: QantasGroupCreditVoucherPayment;
};

export type CreateDateAmendmentInput = {
  checkIn: Scalars['String'];
  checkOut: Scalars['String'];
};

export type CreateDateAmendmentRequestInput = {
  checkIn: Scalars['String'];
  checkOut: Scalars['String'];
  phoneNumber: Scalars['String'];
  email: Scalars['String'];
};

export type CreateSoftAmendmentInput = {
  email: Scalars['String'];
  phone: Scalars['String'];
  qffNumber?: Maybe<Scalars['String']>;
  businessNumber?: Maybe<Scalars['String']>;
};

export type CreditCardPayment = {
  __typename?: 'CreditCardPayment';
  total: Scalars['String'];
  paymentMethod?: Maybe<CreditCardPaymentMethod>;
};

export type CreditCardPaymentMethod = PaymentMethod & {
  __typename?: 'CreditCardPaymentMethod';
  id?: Maybe<Scalars['ID']>;
  method: PaymentMethodType;
  cardType?: Maybe<Scalars['String']>;
  nameOnCard?: Maybe<Scalars['String']>;
  expiryMonth?: Maybe<Scalars['String']>;
  expiryYear?: Maybe<Scalars['String']>;
  lastFourDigits: Scalars['String'];
};

export type CreditNotePayment = {
  __typename?: 'CreditNotePayment';
  total: Scalars['String'];
  paymentMethod?: Maybe<CreditNotePaymentMethod>;
};

export type CreditNotePaymentMethod = PaymentMethod & {
  __typename?: 'CreditNotePaymentMethod';
  id?: Maybe<Scalars['ID']>;
  method: PaymentMethodType;
  lastFourCharacters: Scalars['String'];
  expiry: Scalars['String'];
  brand: Scalars['String'];
};

export type CreditNoteSummary = {
  __typename?: 'CreditNoteSummary';
  total: Total;
  bonusPoints: Scalars['Int'];
  bonusPointsTotal: Total;
};

export type ImageAttributes = {
  __typename?: 'ImageAttributes';
  src: Scalars['String'];
  alt: Scalars['String'];
};

export type ImageSize = 'SMALL' | 'MEDIUM' | 'LARGE';

export type Inclusion = {
  __typename?: 'Inclusion';
  name: Scalars['String'];
};

export type LeadGuest = {
  __typename?: 'LeadGuest';
  name: Name;
  qffNumber?: Maybe<Scalars['String']>;
};

export type MainImage = {
  __typename?: 'MainImage';
  urlSmall: Scalars['String'];
  urlMedium: Scalars['String'];
  urlLarge: Scalars['String'];
  urlOriginal: Scalars['String'];
  caption: Scalars['String'];
};

export type Member = {
  __typename?: 'Member';
  memberId: Scalars['String'];
  title: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  pointsBalance: Scalars['String'];
  membershipTier: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']>;
  acceptAmendment: Amendment;
  acceptCancellation: Cancellation;
  addCreditCard: AddPaymentMethod;
  createCancellation: Cancellation;
  createDateAmendment: Amendment;
  createDateAmendmentRequest: AmendmentRequest;
  createSoftAmendment: Amendment;
};

export type MutationAcceptAmendmentArgs = {
  bookingId: Scalars['ID'];
  amendmentId: Scalars['ID'];
};

export type MutationAcceptCancellationArgs = {
  bookingId: Scalars['ID'];
  cancellationId: Scalars['ID'];
  input?: Maybe<AcceptCancellationInput>;
};

export type MutationAddCreditCardArgs = {
  bookingId: Scalars['ID'];
  input: AddCreditCardInput;
};

export type MutationCreateCancellationArgs = {
  bookingId: Scalars['ID'];
};

export type MutationCreateDateAmendmentArgs = {
  bookingId: Scalars['ID'];
  input: CreateDateAmendmentInput;
};

export type MutationCreateDateAmendmentRequestArgs = {
  bookingId: Scalars['ID'];
  input: CreateDateAmendmentRequestInput;
};

export type MutationCreateSoftAmendmentArgs = {
  bookingId: Scalars['ID'];
  input: CreateSoftAmendmentInput;
};

export type Name = {
  __typename?: 'Name';
  title: Scalars['String'];
  given: Scalars['String'];
  family: Scalars['String'];
};

export type Offer = {
  __typename?: 'Offer';
  id: Scalars['ID'];
  type: Scalars['String'];
  name: Scalars['String'];
  description: Scalars['String'];
  promotion?: Maybe<Promotion>;
  inclusions: Array<Inclusion>;
};

export type PaidBeforeCancellation = {
  __typename?: 'PaidBeforeCancellation';
  totals: Array<Total>;
  breakdown: Array<PaymentMethodBreakdown>;
};

export type PayableAtProperty = {
  __typename?: 'PayableAtProperty';
  total: Total;
  breakdown: Array<PayableAtPropertyBreakdown>;
};

export type PayableAtPropertyBreakdown = {
  __typename?: 'PayableAtPropertyBreakdown';
  description: Scalars['String'];
  charge: Total;
};

export type PaymentAllocation = {
  __typename?: 'PaymentAllocation';
  paymentMethod: BookingPaymentMethod;
  allocation: Total;
};

export type PaymentAttempt = {
  __typename?: 'PaymentAttempt';
  status: PaymentStatus;
  scheduledAt?: Maybe<Scalars['String']>;
  attemptedAt?: Maybe<Scalars['String']>;
  paymentAllocations: Array<PaymentAllocation>;
};

export type PaymentMethod = {
  id?: Maybe<Scalars['ID']>;
  method: PaymentMethodType;
};

export type PaymentMethodBreakdown = {
  __typename?: 'PaymentMethodBreakdown';
  total: Total;
  method: Scalars['String'];
  paymentMethods: Array<PaymentMethod>;
};

export type PaymentMethodType = 'credit_card' | 'points' | 'voucher' | 'credit_note' | 'qantas_group_credit_voucher' | 'qantas_travel_pass';

export type PaymentStatus = 'PENDING' | 'SUCCESSFUL' | 'FAILED';

export type PlatformError = {
  __typename?: 'PlatformError';
  code: Scalars['String'];
};

export type PointsClubTier = 'NONE' | 'POINTS_CLUB' | 'POINTS_CLUB_PLUS';

export type PointsPayment = {
  __typename?: 'PointsPayment';
  total: Scalars['String'];
  paymentMethod?: Maybe<PointsPaymentMethod>;
};

export type PointsPaymentMethod = PaymentMethod & {
  __typename?: 'PointsPaymentMethod';
  id?: Maybe<Scalars['ID']>;
  method: PaymentMethodType;
  qffNumber: Scalars['String'];
};

export type Promotion = {
  __typename?: 'Promotion';
  name: Scalars['String'];
  description: Scalars['String'];
};

export type Property = {
  __typename?: 'Property';
  id: Scalars['ID'];
  propertyUrl: Scalars['String'];
  name: Scalars['String'];
  category: Scalars['String'];
  checkInAfter: Scalars['String'];
  checkOutBefore: Scalars['String'];
  address: Address;
  checkInInstructions?: Maybe<Scalars['String']>;
  rating: Scalars['String'];
  ratingType: PropertyRatingType;
  mainImage?: Maybe<MainImage>;
  roomInformation?: Maybe<Scalars['String']>;
  knowBeforeYouGoDescription?: Maybe<Scalars['String']>;
  mandatoryFeesDescription?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  latitude: Scalars['String'];
  longitude: Scalars['String'];
  propertyFacilities: Array<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  formattedAddress: Scalars['String'];
  formattedAddressFull: Scalars['String'];
};

export type PropertyRatingType = 'AAA' | 'SELF_RATED';

export type QantasGroupCreditVoucherPayment = {
  __typename?: 'QantasGroupCreditVoucherPayment';
  total: Scalars['String'];
  paymentMethod?: Maybe<QantasGroupCreditVoucherPaymentMethod>;
};

export type QantasGroupCreditVoucherPaymentMethod = PaymentMethod & {
  __typename?: 'QantasGroupCreditVoucherPaymentMethod';
  id?: Maybe<Scalars['ID']>;
  method: PaymentMethodType;
  cardNumber?: Maybe<Scalars['String']>;
  expiryMonth?: Maybe<Scalars['String']>;
  expiryYear?: Maybe<Scalars['String']>;
};

export type QbrClaim = {
  __typename?: 'QbrClaim';
  id: Scalars['ID'];
  claimType: Scalars['String'];
  businessNumber: Scalars['String'];
  basePointsAmount: Scalars['Float'];
  bonusPointsAmount: Scalars['Float'];
  state: Scalars['String'];
  awardedOn: Scalars['String'];
};

export type QffClaim = {
  __typename?: 'QffClaim';
  id: Scalars['ID'];
  claimType: Scalars['String'];
  qffNumber: Scalars['String'];
  basePointsAmount: Scalars['Float'];
  bonusPointsAmount: Scalars['Float'];
  state: Scalars['String'];
  awardedOn: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']>;
  amendment: Amendment;
  availabilityCalendar: AvailabilityCalendar;
  booking: Booking;
  bookingAuthMethod: BookingAuthMethod;
  bookingList: BookingList;
  cancellation: Cancellation;
  maintenanceWindowMessage?: Maybe<Scalars['String']>;
  member: Member;
  paymentMethodAmendment: AddPaymentMethod;
};

export type QueryAmendmentArgs = {
  bookingId: Scalars['ID'];
  amendmentId: Scalars['ID'];
};

export type QueryAvailabilityCalendarArgs = {
  bookingId: Scalars['ID'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
};

export type QueryBookingArgs = {
  bookingId: Scalars['ID'];
};

export type QueryBookingAuthMethodArgs = {
  bookingId: Scalars['ID'];
};

export type QueryBookingListArgs = {
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  accountId: Scalars['String'];
  filter?: Maybe<BookingListFilter>;
};

export type QueryCancellationArgs = {
  bookingId: Scalars['ID'];
  cancellationId: Scalars['ID'];
};

export type QueryMemberArgs = {
  memberId: Scalars['String'];
};

export type QueryPaymentMethodAmendmentArgs = {
  bookingId: Scalars['ID'];
  paymentMethodId: Scalars['ID'];
};

export type RefundType = 'NORMAL' | 'CREDIT_NOTE';

export type Reservation = {
  __typename?: 'Reservation';
  id: Scalars['ID'];
  createdAt: Scalars['String'];
  cancellationPolicy?: Maybe<CancellationPolicy>;
  qffClaims: Array<QffClaim>;
  qbrClaims: Array<QbrClaim>;
  property: Property;
  leadGuest: LeadGuest;
  offer: Offer;
  roomType: RoomType;
  bedGroupDescription?: Maybe<Scalars['String']>;
  checkIn: Scalars['String'];
  checkOut: Scalars['String'];
  checkInDateTime: Scalars['String'];
  checkOutDateTime: Scalars['String'];
  specialRequests?: Maybe<Scalars['String']>;
  adults: Scalars['Int'];
  children: Scalars['Int'];
  infants: Scalars['Int'];
  permittedOfflineRequests: Array<Scalars['String']>;
  totalGuests: Scalars['Int'];
  isBeforeCheckInDay: Scalars['Boolean'];
  isAfterCheckOut: Scalars['Boolean'];
  formattedCheckIn: Scalars['String'];
  formattedCheckOut: Scalars['String'];
  qffEarnNumber: Scalars['String'];
  pointsClubTier: PointsClubTier;
  totalQffPointsEarned: Scalars['Int'];
  totalQffPointsAwarded: Scalars['Int'];
  totalQbrPoints: Scalars['Int'];
};

export type RoomType = {
  __typename?: 'RoomType';
  id: Scalars['ID'];
  name: Scalars['String'];
  description: Scalars['String'];
  roomTypeFacilities: Array<Scalars['String']>;
};

export type ScheduledPayment = {
  __typename?: 'ScheduledPayment';
  transactionId: Scalars['String'];
  deferredTo: Scalars['String'];
  total: Total;
  attempts: Array<PaymentAttempt>;
};

export type Total = {
  __typename?: 'Total';
  amount: Scalars['String'];
  currency: Scalars['String'];
};

export type Transaction = {
  __typename?: 'Transaction';
  id: Scalars['ID'];
  type: TransactionType;
  reason: TransactionReason;
  changeId: Scalars['String'];
  createdAt: Scalars['String'];
  chargeBreakdown: ChargeBreakdown;
};

export type TransactionReason = 'CREATION' | 'AMENDMENT' | 'CANCELLATION';

export type TransactionType = 'PAYMENT' | 'REFUND';

export type TravelArranger = {
  __typename?: 'TravelArranger';
  name: Name;
  email: Scalars['String'];
  phone: Scalars['String'];
  businessRegistrationNumber: Scalars['String'];
};

export type VoucherPayment = {
  __typename?: 'VoucherPayment';
  total: Scalars['String'];
  paymentMethod?: Maybe<VoucherPaymentMethod>;
};

export type VoucherPaymentMethod = PaymentMethod & {
  __typename?: 'VoucherPaymentMethod';
  id?: Maybe<Scalars['ID']>;
  method: PaymentMethodType;
  code: Scalars['String'];
  brand: Scalars['String'];
};

export type PointsPaymentMethodFieldsFragment = { __typename?: 'PointsPaymentMethod' } & Pick<
  PointsPaymentMethod,
  'id' | 'method' | 'qffNumber'
>;

export type VoucherPaymentMethodFieldsFragment = { __typename?: 'VoucherPaymentMethod' } & Pick<
  VoucherPaymentMethod,
  'id' | 'method' | 'code' | 'brand'
>;

export type CreditCardPaymentMethodFieldsFragment = { __typename?: 'CreditCardPaymentMethod' } & Pick<
  CreditCardPaymentMethod,
  'method' | 'cardType' | 'lastFourDigits' | 'expiryMonth' | 'expiryYear'
>;

export type CreditNotePaymentMethodFieldsFragment = { __typename?: 'CreditNotePaymentMethod' } & Pick<
  CreditNotePaymentMethod,
  'id' | 'method' | 'lastFourCharacters' | 'expiry'
>;

export type QantasGroupCreditVoucherPaymentMethodFieldsFragment = { __typename?: 'QantasGroupCreditVoucherPaymentMethod' } & Pick<
  QantasGroupCreditVoucherPaymentMethod,
  'id' | 'method' | 'cardNumber'
>;

export type PaymentMethodBreakdownFieldsFragment = { __typename?: 'PaymentMethodBreakdown' } & Pick<PaymentMethodBreakdown, 'method'> & {
    total: { __typename?: 'Total' } & Pick<Total, 'amount' | 'currency'>;
    paymentMethods: Array<
      | ({ __typename?: 'CreditCardPaymentMethod' } & CreditCardPaymentMethodFieldsFragment)
      | ({ __typename?: 'PointsPaymentMethod' } & PointsPaymentMethodFieldsFragment)
      | ({ __typename?: 'VoucherPaymentMethod' } & VoucherPaymentMethodFieldsFragment)
      | ({ __typename?: 'CreditNotePaymentMethod' } & CreditNotePaymentMethodFieldsFragment)
      | ({ __typename?: 'QantasGroupCreditVoucherPaymentMethod' } & QantasGroupCreditVoucherPaymentMethodFieldsFragment)
    >;
  };

export type CancellationFragmentFragment = { __typename?: 'Cancellation' } & Pick<
  Cancellation,
  'id' | 'state' | 'createdAt' | 'completedAt' | 'isCreditCardExpired'
> & {
    errors?: Maybe<Array<{ __typename?: 'PlatformError' } & Pick<PlatformError, 'code'>>>;
    refund?: Maybe<
      { __typename?: 'CancellationRefund' } & {
        totals: Array<{ __typename?: 'Total' } & Pick<Total, 'amount' | 'currency'>>;
        penalty: Array<{ __typename?: 'Total' } & Pick<Total, 'amount' | 'currency'>>;
        breakdown: Array<{ __typename?: 'PaymentMethodBreakdown' } & PaymentMethodBreakdownFieldsFragment>;
      }
    >;
    creditNote?: Maybe<{ __typename?: 'CreditNoteSummary' } & { total: { __typename?: 'Total' } & Pick<Total, 'amount' | 'currency'> }>;
  };

export type ScheduledPaymentFragmentFragment = { __typename?: 'ScheduledPayment' } & Pick<ScheduledPayment, 'deferredTo'> & {
    total: { __typename?: 'Total' } & Pick<Total, 'amount' | 'currency'>;
    attempts: Array<
      { __typename?: 'PaymentAttempt' } & Pick<PaymentAttempt, 'status' | 'scheduledAt' | 'attemptedAt'> & {
          paymentAllocations: Array<
            { __typename?: 'PaymentAllocation' } & {
              paymentMethod:
                | ({ __typename?: 'CreditCardPaymentMethod' } & CreditCardPaymentMethodFieldsFragment)
                | ({ __typename?: 'PointsPaymentMethod' } & PointsPaymentMethodFieldsFragment)
                | ({ __typename?: 'VoucherPaymentMethod' } & VoucherPaymentMethodFieldsFragment)
                | ({ __typename?: 'CreditNotePaymentMethod' } & CreditNotePaymentMethodFieldsFragment)
                | ({ __typename?: 'QantasGroupCreditVoucherPaymentMethod' } & QantasGroupCreditVoucherPaymentMethodFieldsFragment);
              allocation: { __typename?: 'Total' } & Pick<Total, 'amount' | 'currency'>;
            }
          >;
        }
    >;
  };

export type AcceptAmendmentMutationVariables = Exact<{
  bookingId: Scalars['ID'];
  amendmentId: Scalars['ID'];
}>;

export type AcceptAmendmentMutation = { __typename?: 'Mutation' } & {
  acceptAmendment: { __typename?: 'Amendment' } & Pick<Amendment, 'id' | 'state'>;
};

export type PaymentMethodAmendmentFragmentFragment = { __typename?: 'AddPaymentMethod' } & Pick<AddPaymentMethod, 'id' | 'state'>;

export type AddCreditCardMutationVariables = Exact<{
  bookingId: Scalars['ID'];
  input: AddCreditCardInput;
}>;

export type AddCreditCardMutation = { __typename?: 'Mutation' } & {
  addCreditCard: { __typename?: 'AddPaymentMethod' } & PaymentMethodAmendmentFragmentFragment;
};

export type PaymentMethodAmendmentQueryVariables = Exact<{
  bookingId: Scalars['ID'];
  paymentMethodId: Scalars['ID'];
}>;

export type PaymentMethodAmendmentQuery = { __typename?: 'Query' } & {
  paymentMethodAmendment: { __typename?: 'AddPaymentMethod' } & PaymentMethodAmendmentFragmentFragment;
};

export type CreateDateAmendmentMutationVariables = Exact<{
  bookingId: Scalars['ID'];
  input: CreateDateAmendmentInput;
}>;

export type CreateDateAmendmentMutation = { __typename?: 'Mutation' } & {
  createDateAmendment: { __typename?: 'Amendment' } & Pick<Amendment, 'id' | 'state'>;
};

export type CreateDateAmendmentRequestMutationVariables = Exact<{
  bookingId: Scalars['ID'];
  input: CreateDateAmendmentRequestInput;
}>;

export type CreateDateAmendmentRequestMutation = { __typename?: 'Mutation' } & {
  createDateAmendmentRequest: { __typename?: 'AmendmentRequest' } & Pick<AmendmentRequest, 'bookingId' | 'caseNumber'>;
};

export type CreateSoftAmendmentMutationVariables = Exact<{
  bookingId: Scalars['ID'];
  input: CreateSoftAmendmentInput;
}>;

export type CreateSoftAmendmentMutation = { __typename?: 'Mutation' } & {
  createSoftAmendment: { __typename?: 'Amendment' } & Pick<Amendment, 'id' | 'state'>;
};

export type AmendmentQueryVariables = Exact<{
  bookingId: Scalars['ID'];
  amendmentId: Scalars['ID'];
}>;

export type AmendmentQuery = { __typename?: 'Query' } & {
  amendment: { __typename?: 'Amendment' } & Pick<Amendment, 'id' | 'state' | 'createdAt' | 'completedAt'> & {
      cancellationPolicy?: Maybe<{ __typename?: 'CancellationPolicy' } & Pick<CancellationPolicy, 'description'>>;
      errors?: Maybe<Array<{ __typename?: 'PlatformError' } & Pick<PlatformError, 'code'>>>;
      amendmentTotal?: Maybe<
        { __typename?: 'AmendmentTotal' } & Pick<AmendmentTotal, 'type'> & {
            totals: Array<{ __typename?: 'Total' } & Pick<Total, 'amount' | 'currency'>>;
            adjustment: Array<{ __typename?: 'Total' } & Pick<Total, 'amount' | 'currency'>>;
            breakdown: Array<
              { __typename?: 'PaymentMethodBreakdown' } & Pick<PaymentMethodBreakdown, 'method'> & {
                  total: { __typename?: 'Total' } & Pick<Total, 'amount' | 'currency'>;
                  paymentMethods: Array<
                    | ({ __typename?: 'CreditCardPaymentMethod' } & Pick<
                        CreditCardPaymentMethod,
                        'cardType' | 'expiryMonth' | 'expiryYear' | 'lastFourDigits' | 'id' | 'method'
                      >)
                    | ({ __typename?: 'PointsPaymentMethod' } & Pick<PointsPaymentMethod, 'qffNumber' | 'id' | 'method'>)
                    | ({ __typename?: 'VoucherPaymentMethod' } & Pick<VoucherPaymentMethod, 'code' | 'brand' | 'id' | 'method'>)
                    | ({ __typename?: 'CreditNotePaymentMethod' } & Pick<CreditNotePaymentMethod, 'id' | 'method'>)
                    | ({ __typename?: 'QantasGroupCreditVoucherPaymentMethod' } & Pick<
                        QantasGroupCreditVoucherPaymentMethod,
                        'id' | 'method'
                      >)
                  >;
                }
            >;
          }
      >;
      payableAtProperty?: Maybe<
        { __typename?: 'PayableAtProperty' } & { total: { __typename?: 'Total' } & Pick<Total, 'amount' | 'currency'> }
      >;
    };
};

export type AvailabilityCalendarQueryVariables = Exact<{
  bookingId: Scalars['ID'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
}>;

export type AvailabilityCalendarQuery = { __typename?: 'Query' } & {
  availabilityCalendar: { __typename?: 'AvailabilityCalendar' } & {
    stays: Array<Maybe<{ __typename?: 'AvailableStay' } & Pick<AvailableStay, 'checkIn' | 'available'>>>;
  };
};

export type BookingAuthMethodQueryVariables = Exact<{
  bookingId: Scalars['ID'];
}>;

export type BookingAuthMethodQuery = { __typename?: 'Query' } & { authMethod: Query['bookingAuthMethod'] };

export type BookingDetailsQueryVariables = Exact<{
  bookingId: Scalars['ID'];
}>;

export type BookingDetailsQuery = { __typename?: 'Query' } & {
  booking: { __typename?: 'Booking' } & Pick<Booking, 'id' | 'createdAt' | 'state' | 'reference' | 'channel' | 'nights' | 'summaryText'> & {
      flags: { __typename?: 'BookingFlags' } & Pick<
        BookingFlags,
        | 'isFinalising'
        | 'isBooked'
        | 'isBlocked'
        | 'isCancelled'
        | 'isChangeInProgress'
        | 'isRateable'
        | 'isCancelable'
        | 'isCancelableInApp'
        | 'isCancelableByPhone'
        | 'isDateAmendableInApp'
        | 'isChangeDatesRequestEnabled'
        | 'isCreditCardExpired'
        | 'hasPendingScheduledPayment'
        | 'hasAppleWalletPass'
        | 'requiresPaymentMethodUpdate'
      >;
      cancellationRefund?: Maybe<
        { __typename?: 'CancellationRefund' } & {
          totals: Array<{ __typename?: 'Total' } & Pick<Total, 'amount' | 'currency'>>;
          penalty: Array<{ __typename?: 'Total' } & Pick<Total, 'amount' | 'currency'>>;
          breakdown: Array<{ __typename?: 'PaymentMethodBreakdown' } & PaymentMethodBreakdownFieldsFragment>;
        }
      >;
      paidBeforeCancellation: { __typename?: 'PaidBeforeCancellation' } & {
        totals: Array<{ __typename?: 'Total' } & Pick<Total, 'amount' | 'currency'>>;
        breakdown: Array<{ __typename?: 'PaymentMethodBreakdown' } & PaymentMethodBreakdownFieldsFragment>;
      };
      payableAtProperty?: Maybe<
        { __typename?: 'PayableAtProperty' } & {
          total: { __typename?: 'Total' } & Pick<Total, 'amount' | 'currency'>;
          breakdown: Array<
            { __typename?: 'PayableAtPropertyBreakdown' } & Pick<PayableAtPropertyBreakdown, 'description'> & {
                charge: { __typename?: 'Total' } & Pick<Total, 'amount' | 'currency'>;
              }
          >;
        }
      >;
      links: { __typename?: 'BookingLinks' } & Pick<
        BookingLinks,
        'manage' | 'rebook' | 'updatePaymentMethod' | 'print' | 'googleMaps' | 'downloadInvoice' | 'downloadAppleWalletPass'
      >;
      travelArranger: { __typename?: 'TravelArranger' } & Pick<TravelArranger, 'email' | 'phone' | 'businessRegistrationNumber'>;
      reservation: { __typename?: 'Reservation' } & Pick<
        Reservation,
        | 'checkIn'
        | 'checkOut'
        | 'checkInDateTime'
        | 'checkOutDateTime'
        | 'specialRequests'
        | 'formattedCheckIn'
        | 'formattedCheckOut'
        | 'isBeforeCheckInDay'
        | 'isAfterCheckOut'
        | 'adults'
        | 'children'
        | 'infants'
        | 'qffEarnNumber'
        | 'pointsClubTier'
        | 'totalQffPointsEarned'
        | 'totalQffPointsAwarded'
        | 'totalQbrPoints'
        | 'bedGroupDescription'
      > & {
          roomType: { __typename?: 'RoomType' } & Pick<RoomType, 'name' | 'description'>;
          offer: { __typename?: 'Offer' } & Pick<Offer, 'name' | 'type' | 'description'> & {
              inclusions: Array<{ __typename?: 'Inclusion' } & Pick<Inclusion, 'name'>>;
            };
          leadGuest: { __typename?: 'LeadGuest' } & Pick<LeadGuest, 'qffNumber'> & {
              name: { __typename?: 'Name' } & Pick<Name, 'title' | 'given' | 'family'>;
            };
          property: { __typename?: 'Property' } & Pick<
            Property,
            | 'id'
            | 'name'
            | 'email'
            | 'phone'
            | 'rating'
            | 'ratingType'
            | 'formattedAddress'
            | 'formattedAddressFull'
            | 'description'
            | 'checkInInstructions'
            | 'roomInformation'
            | 'knowBeforeYouGoDescription'
            | 'mandatoryFeesDescription'
            | 'checkInAfter'
            | 'checkOutBefore'
          >;
          cancellationPolicy?: Maybe<
            { __typename?: 'CancellationPolicy' } & Pick<CancellationPolicy, 'description'> & {
                activeCancellationWindow?: Maybe<
                  { __typename?: 'CancellationWindow' } & Pick<
                    CancellationWindow,
                    'isFullyRefundable' | 'isNonRefundable' | 'isPartiallyRefundable' | 'endTime'
                  >
                >;
                cancellationWindows: Array<
                  { __typename?: 'CancellationWindow' } & Pick<
                    CancellationWindow,
                    'cancellationType' | 'startTime' | 'endTime' | 'isFullyRefundable' | 'isPartiallyRefundable' | 'isNonRefundable'
                  >
                >;
              }
          >;
        };
      mediumImage: { __typename?: 'ImageAttributes' } & Pick<ImageAttributes, 'src' | 'alt'>;
      largeImage: { __typename?: 'ImageAttributes' } & Pick<ImageAttributes, 'src' | 'alt'>;
      transactions: Array<
        { __typename?: 'Transaction' } & Pick<Transaction, 'type' | 'reason' | 'createdAt'> & {
            chargeBreakdown: { __typename?: 'ChargeBreakdown' } & {
              creditCard: { __typename?: 'CreditCardPayment' } & Pick<CreditCardPayment, 'total'> & {
                  paymentMethod?: Maybe<{ __typename?: 'CreditCardPaymentMethod' } & CreditCardPaymentMethodFieldsFragment>;
                };
              points: { __typename?: 'PointsPayment' } & Pick<PointsPayment, 'total'> & {
                  paymentMethod?: Maybe<{ __typename?: 'PointsPaymentMethod' } & PointsPaymentMethodFieldsFragment>;
                };
              voucher: { __typename?: 'VoucherPayment' } & Pick<VoucherPayment, 'total'> & {
                  paymentMethod?: Maybe<{ __typename?: 'VoucherPaymentMethod' } & VoucherPaymentMethodFieldsFragment>;
                };
              creditNote: { __typename?: 'CreditNotePayment' } & Pick<CreditNotePayment, 'total'> & {
                  paymentMethod?: Maybe<{ __typename?: 'CreditNotePaymentMethod' } & CreditNotePaymentMethodFieldsFragment>;
                };
              qantasGroupCreditVoucher: { __typename?: 'QantasGroupCreditVoucherPayment' } & Pick<
                QantasGroupCreditVoucherPayment,
                'total'
              > & {
                  paymentMethod?: Maybe<
                    { __typename?: 'QantasGroupCreditVoucherPaymentMethod' } & QantasGroupCreditVoucherPaymentMethodFieldsFragment
                  >;
                };
            };
          }
      >;
      paymentSchedule: Array<{ __typename?: 'ScheduledPayment' } & ScheduledPaymentFragmentFragment>;
      payableAtBooking: { __typename?: 'Total' } & Pick<Total, 'amount' | 'currency'>;
      payableTotals: Array<{ __typename?: 'Total' } & Pick<Total, 'amount' | 'currency'>>;
    };
};

export type BookingListQueryVariables = Exact<{
  accountId: Scalars['String'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  filter?: Maybe<BookingListFilter>;
}>;

export type BookingListQuery = { __typename?: 'Query' } & {
  bookingList: { __typename?: 'BookingList' } & Pick<BookingList, 'hasMore'> & {
      bookings: Array<
        { __typename?: 'Booking' } & Pick<Booking, 'id' | 'reference' | 'nights'> & {
            payableTotals: Array<{ __typename?: 'Total' } & Pick<Total, 'amount' | 'currency'>>;
            flags: { __typename?: 'BookingFlags' } & Pick<
              BookingFlags,
              | 'isBooked'
              | 'isBlocked'
              | 'isCancelled'
              | 'isChangeInProgress'
              | 'isRateable'
              | 'isCreditCardExpired'
              | 'isFinalising'
              | 'hasPendingScheduledPayment'
              | 'requiresPaymentMethodUpdate'
            >;
            image: { __typename?: 'ImageAttributes' } & Pick<ImageAttributes, 'src' | 'alt'>;
            links: { __typename?: 'BookingLinks' } & Pick<BookingLinks, 'manage' | 'print' | 'rebook' | 'updatePaymentMethod'>;
            reservation: { __typename?: 'Reservation' } & Pick<
              Reservation,
              | 'totalGuests'
              | 'adults'
              | 'children'
              | 'infants'
              | 'formattedCheckIn'
              | 'formattedCheckOut'
              | 'isAfterCheckOut'
              | 'checkIn'
              | 'checkOut'
            > & {
                roomType: { __typename?: 'RoomType' } & Pick<RoomType, 'name'>;
                property: { __typename?: 'Property' } & Pick<Property, 'id' | 'name' | 'formattedAddress'> & {
                    address: { __typename?: 'Address' } & Pick<Address, 'suburb'>;
                  };
                cancellationPolicy?: Maybe<
                  { __typename?: 'CancellationPolicy' } & {
                    activeCancellationWindow?: Maybe<
                      { __typename?: 'CancellationWindow' } & Pick<
                        CancellationWindow,
                        'cancellationType' | 'endTime' | 'startTime' | 'isFullyRefundable' | 'isNonRefundable'
                      >
                    >;
                  }
                >;
              };
            paymentSchedule: Array<{ __typename?: 'ScheduledPayment' } & ScheduledPaymentFragmentFragment>;
          }
      >;
    };
};

export type GetCancellationQueryVariables = Exact<{
  bookingId: Scalars['ID'];
  cancellationId: Scalars['ID'];
}>;

export type GetCancellationQuery = { __typename?: 'Query' } & {
  cancellation: { __typename?: 'Cancellation' } & CancellationFragmentFragment;
};

export type CreateCancellationMutationVariables = Exact<{
  bookingId: Scalars['ID'];
}>;

export type CreateCancellationMutation = { __typename?: 'Mutation' } & {
  createCancellation: { __typename?: 'Cancellation' } & CancellationFragmentFragment;
};

export type AcceptCancellationMutationVariables = Exact<{
  bookingId: Scalars['ID'];
  cancellationId: Scalars['ID'];
  input: AcceptCancellationInput;
}>;

export type AcceptCancellationMutation = { __typename?: 'Mutation' } & {
  acceptCancellation: { __typename?: 'Cancellation' } & CancellationFragmentFragment;
};

export type MemberQueryVariables = Exact<{
  memberId: Scalars['String'];
}>;

export type MemberQuery = { __typename?: 'Query' } & {
  member: { __typename?: 'Member' } & Pick<Member, 'memberId' | 'title' | 'firstName' | 'lastName' | 'pointsBalance' | 'membershipTier'>;
};

export const PointsPaymentMethodFieldsFragmentDoc = gql`
  fragment pointsPaymentMethodFields on PointsPaymentMethod {
    id
    method
    qffNumber
  }
`;
export const VoucherPaymentMethodFieldsFragmentDoc = gql`
  fragment voucherPaymentMethodFields on VoucherPaymentMethod {
    id
    method
    code
    brand
  }
`;
export const CreditCardPaymentMethodFieldsFragmentDoc = gql`
  fragment creditCardPaymentMethodFields on CreditCardPaymentMethod {
    method
    cardType
    lastFourDigits
    expiryMonth
    expiryYear
  }
`;
export const CreditNotePaymentMethodFieldsFragmentDoc = gql`
  fragment creditNotePaymentMethodFields on CreditNotePaymentMethod {
    id
    method
    lastFourCharacters
    expiry
  }
`;
export const QantasGroupCreditVoucherPaymentMethodFieldsFragmentDoc = gql`
  fragment qantasGroupCreditVoucherPaymentMethodFields on QantasGroupCreditVoucherPaymentMethod {
    id
    method
    cardNumber
  }
`;
export const PaymentMethodBreakdownFieldsFragmentDoc = gql`
  fragment paymentMethodBreakdownFields on PaymentMethodBreakdown {
    method
    total {
      amount
      currency
    }
    paymentMethods {
      ...pointsPaymentMethodFields
      ...voucherPaymentMethodFields
      ...creditCardPaymentMethodFields
      ...creditNotePaymentMethodFields
      ...qantasGroupCreditVoucherPaymentMethodFields
    }
  }
  ${PointsPaymentMethodFieldsFragmentDoc}
  ${VoucherPaymentMethodFieldsFragmentDoc}
  ${CreditCardPaymentMethodFieldsFragmentDoc}
  ${CreditNotePaymentMethodFieldsFragmentDoc}
  ${QantasGroupCreditVoucherPaymentMethodFieldsFragmentDoc}
`;
export const CancellationFragmentFragmentDoc = gql`
  fragment cancellationFragment on Cancellation {
    id
    state
    createdAt
    completedAt
    isCreditCardExpired
    errors {
      code
    }
    refund {
      totals {
        amount
        currency
      }
      penalty {
        amount
        currency
      }
      breakdown {
        ...paymentMethodBreakdownFields
      }
    }
    creditNote {
      total {
        amount
        currency
      }
    }
  }
  ${PaymentMethodBreakdownFieldsFragmentDoc}
`;
export const ScheduledPaymentFragmentFragmentDoc = gql`
  fragment scheduledPaymentFragment on ScheduledPayment {
    deferredTo
    total {
      amount
      currency
    }
    attempts {
      status
      scheduledAt
      attemptedAt
      paymentAllocations {
        paymentMethod {
          ...creditCardPaymentMethodFields
          ...pointsPaymentMethodFields
          ...voucherPaymentMethodFields
          ...creditNotePaymentMethodFields
          ...qantasGroupCreditVoucherPaymentMethodFields
        }
        allocation {
          amount
          currency
        }
      }
    }
  }
  ${CreditCardPaymentMethodFieldsFragmentDoc}
  ${PointsPaymentMethodFieldsFragmentDoc}
  ${VoucherPaymentMethodFieldsFragmentDoc}
  ${CreditNotePaymentMethodFieldsFragmentDoc}
  ${QantasGroupCreditVoucherPaymentMethodFieldsFragmentDoc}
`;
export const PaymentMethodAmendmentFragmentFragmentDoc = gql`
  fragment paymentMethodAmendmentFragment on AddPaymentMethod {
    id
    state
  }
`;
export const AcceptAmendmentDocument = gql`
  mutation AcceptAmendment($bookingId: ID!, $amendmentId: ID!) {
    acceptAmendment(bookingId: $bookingId, amendmentId: $amendmentId) {
      id
      state
    }
  }
`;
export type AcceptAmendmentMutationFn = ApolloReactCommon.MutationFunction<AcceptAmendmentMutation, AcceptAmendmentMutationVariables>;

/**
 * __useAcceptAmendmentMutation__
 *
 * To run a mutation, you first call `useAcceptAmendmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptAmendmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptAmendmentMutation, { data, loading, error }] = useAcceptAmendmentMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      amendmentId: // value for 'amendmentId'
 *   },
 * });
 */
export function useAcceptAmendmentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptAmendmentMutation, AcceptAmendmentMutationVariables>,
) {
  return ApolloReactHooks.useMutation<AcceptAmendmentMutation, AcceptAmendmentMutationVariables>(AcceptAmendmentDocument, baseOptions);
}
export type AcceptAmendmentMutationHookResult = ReturnType<typeof useAcceptAmendmentMutation>;
export type AcceptAmendmentMutationResult = ApolloReactCommon.MutationResult<AcceptAmendmentMutation>;
export type AcceptAmendmentMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AcceptAmendmentMutation,
  AcceptAmendmentMutationVariables
>;
export const AddCreditCardDocument = gql`
  mutation AddCreditCard($bookingId: ID!, $input: AddCreditCardInput!) {
    addCreditCard(bookingId: $bookingId, input: $input) {
      ...paymentMethodAmendmentFragment
    }
  }
  ${PaymentMethodAmendmentFragmentFragmentDoc}
`;
export type AddCreditCardMutationFn = ApolloReactCommon.MutationFunction<AddCreditCardMutation, AddCreditCardMutationVariables>;

/**
 * __useAddCreditCardMutation__
 *
 * To run a mutation, you first call `useAddCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCreditCardMutation, { data, loading, error }] = useAddCreditCardMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCreditCardMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<AddCreditCardMutation, AddCreditCardMutationVariables>,
) {
  return ApolloReactHooks.useMutation<AddCreditCardMutation, AddCreditCardMutationVariables>(AddCreditCardDocument, baseOptions);
}
export type AddCreditCardMutationHookResult = ReturnType<typeof useAddCreditCardMutation>;
export type AddCreditCardMutationResult = ApolloReactCommon.MutationResult<AddCreditCardMutation>;
export type AddCreditCardMutationOptions = ApolloReactCommon.BaseMutationOptions<AddCreditCardMutation, AddCreditCardMutationVariables>;
export const PaymentMethodAmendmentDocument = gql`
  query PaymentMethodAmendment($bookingId: ID!, $paymentMethodId: ID!) {
    paymentMethodAmendment(bookingId: $bookingId, paymentMethodId: $paymentMethodId) {
      ...paymentMethodAmendmentFragment
    }
  }
  ${PaymentMethodAmendmentFragmentFragmentDoc}
`;

/**
 * __usePaymentMethodAmendmentQuery__
 *
 * To run a query within a React component, call `usePaymentMethodAmendmentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodAmendmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodAmendmentQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function usePaymentMethodAmendmentQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<PaymentMethodAmendmentQuery, PaymentMethodAmendmentQueryVariables>,
) {
  return ApolloReactHooks.useQuery<PaymentMethodAmendmentQuery, PaymentMethodAmendmentQueryVariables>(
    PaymentMethodAmendmentDocument,
    baseOptions,
  );
}
export function usePaymentMethodAmendmentLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaymentMethodAmendmentQuery, PaymentMethodAmendmentQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<PaymentMethodAmendmentQuery, PaymentMethodAmendmentQueryVariables>(
    PaymentMethodAmendmentDocument,
    baseOptions,
  );
}
export type PaymentMethodAmendmentQueryHookResult = ReturnType<typeof usePaymentMethodAmendmentQuery>;
export type PaymentMethodAmendmentLazyQueryHookResult = ReturnType<typeof usePaymentMethodAmendmentLazyQuery>;
export type PaymentMethodAmendmentQueryResult = ApolloReactCommon.QueryResult<
  PaymentMethodAmendmentQuery,
  PaymentMethodAmendmentQueryVariables
>;
export const CreateDateAmendmentDocument = gql`
  mutation createDateAmendment($bookingId: ID!, $input: CreateDateAmendmentInput!) {
    createDateAmendment(bookingId: $bookingId, input: $input) {
      id
      state
    }
  }
`;
export type CreateDateAmendmentMutationFn = ApolloReactCommon.MutationFunction<
  CreateDateAmendmentMutation,
  CreateDateAmendmentMutationVariables
>;

/**
 * __useCreateDateAmendmentMutation__
 *
 * To run a mutation, you first call `useCreateDateAmendmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDateAmendmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDateAmendmentMutation, { data, loading, error }] = useCreateDateAmendmentMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDateAmendmentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDateAmendmentMutation, CreateDateAmendmentMutationVariables>,
) {
  return ApolloReactHooks.useMutation<CreateDateAmendmentMutation, CreateDateAmendmentMutationVariables>(
    CreateDateAmendmentDocument,
    baseOptions,
  );
}
export type CreateDateAmendmentMutationHookResult = ReturnType<typeof useCreateDateAmendmentMutation>;
export type CreateDateAmendmentMutationResult = ApolloReactCommon.MutationResult<CreateDateAmendmentMutation>;
export type CreateDateAmendmentMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateDateAmendmentMutation,
  CreateDateAmendmentMutationVariables
>;
export const CreateDateAmendmentRequestDocument = gql`
  mutation createDateAmendmentRequest($bookingId: ID!, $input: CreateDateAmendmentRequestInput!) {
    createDateAmendmentRequest(bookingId: $bookingId, input: $input) {
      bookingId
      caseNumber
    }
  }
`;
export type CreateDateAmendmentRequestMutationFn = ApolloReactCommon.MutationFunction<
  CreateDateAmendmentRequestMutation,
  CreateDateAmendmentRequestMutationVariables
>;

/**
 * __useCreateDateAmendmentRequestMutation__
 *
 * To run a mutation, you first call `useCreateDateAmendmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDateAmendmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDateAmendmentRequestMutation, { data, loading, error }] = useCreateDateAmendmentRequestMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDateAmendmentRequestMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDateAmendmentRequestMutation, CreateDateAmendmentRequestMutationVariables>,
) {
  return ApolloReactHooks.useMutation<CreateDateAmendmentRequestMutation, CreateDateAmendmentRequestMutationVariables>(
    CreateDateAmendmentRequestDocument,
    baseOptions,
  );
}
export type CreateDateAmendmentRequestMutationHookResult = ReturnType<typeof useCreateDateAmendmentRequestMutation>;
export type CreateDateAmendmentRequestMutationResult = ApolloReactCommon.MutationResult<CreateDateAmendmentRequestMutation>;
export type CreateDateAmendmentRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateDateAmendmentRequestMutation,
  CreateDateAmendmentRequestMutationVariables
>;
export const CreateSoftAmendmentDocument = gql`
  mutation CreateSoftAmendment($bookingId: ID!, $input: CreateSoftAmendmentInput!) {
    createSoftAmendment(bookingId: $bookingId, input: $input) {
      id
      state
    }
  }
`;
export type CreateSoftAmendmentMutationFn = ApolloReactCommon.MutationFunction<
  CreateSoftAmendmentMutation,
  CreateSoftAmendmentMutationVariables
>;

/**
 * __useCreateSoftAmendmentMutation__
 *
 * To run a mutation, you first call `useCreateSoftAmendmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSoftAmendmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSoftAmendmentMutation, { data, loading, error }] = useCreateSoftAmendmentMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSoftAmendmentMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSoftAmendmentMutation, CreateSoftAmendmentMutationVariables>,
) {
  return ApolloReactHooks.useMutation<CreateSoftAmendmentMutation, CreateSoftAmendmentMutationVariables>(
    CreateSoftAmendmentDocument,
    baseOptions,
  );
}
export type CreateSoftAmendmentMutationHookResult = ReturnType<typeof useCreateSoftAmendmentMutation>;
export type CreateSoftAmendmentMutationResult = ApolloReactCommon.MutationResult<CreateSoftAmendmentMutation>;
export type CreateSoftAmendmentMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateSoftAmendmentMutation,
  CreateSoftAmendmentMutationVariables
>;
export const AmendmentDocument = gql`
  query Amendment($bookingId: ID!, $amendmentId: ID!) {
    amendment(bookingId: $bookingId, amendmentId: $amendmentId) {
      id
      state
      createdAt
      completedAt
      cancellationPolicy {
        description
      }
      errors {
        code
      }
      amendmentTotal {
        type
        totals {
          amount
          currency
        }
        adjustment {
          amount
          currency
        }
        breakdown {
          total {
            amount
            currency
          }
          method
          paymentMethods {
            id
            method
            ... on CreditCardPaymentMethod {
              cardType
              expiryMonth
              expiryYear
              lastFourDigits
            }
            ... on PointsPaymentMethod {
              qffNumber
            }
            ... on VoucherPaymentMethod {
              code
              brand
            }
          }
        }
      }
      payableAtProperty {
        total {
          amount
          currency
        }
      }
    }
  }
`;

/**
 * __useAmendmentQuery__
 *
 * To run a query within a React component, call `useAmendmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmendmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmendmentQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      amendmentId: // value for 'amendmentId'
 *   },
 * });
 */
export function useAmendmentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AmendmentQuery, AmendmentQueryVariables>) {
  return ApolloReactHooks.useQuery<AmendmentQuery, AmendmentQueryVariables>(AmendmentDocument, baseOptions);
}
export function useAmendmentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AmendmentQuery, AmendmentQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<AmendmentQuery, AmendmentQueryVariables>(AmendmentDocument, baseOptions);
}
export type AmendmentQueryHookResult = ReturnType<typeof useAmendmentQuery>;
export type AmendmentLazyQueryHookResult = ReturnType<typeof useAmendmentLazyQuery>;
export type AmendmentQueryResult = ApolloReactCommon.QueryResult<AmendmentQuery, AmendmentQueryVariables>;
export const AvailabilityCalendarDocument = gql`
  query AvailabilityCalendar($bookingId: ID!, $startDate: String!, $endDate: String!) {
    availabilityCalendar(bookingId: $bookingId, startDate: $startDate, endDate: $endDate) {
      stays {
        checkIn
        available
      }
    }
  }
`;

/**
 * __useAvailabilityCalendarQuery__
 *
 * To run a query within a React component, call `useAvailabilityCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailabilityCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailabilityCalendarQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useAvailabilityCalendarQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<AvailabilityCalendarQuery, AvailabilityCalendarQueryVariables>,
) {
  return ApolloReactHooks.useQuery<AvailabilityCalendarQuery, AvailabilityCalendarQueryVariables>(
    AvailabilityCalendarDocument,
    baseOptions,
  );
}
export function useAvailabilityCalendarLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AvailabilityCalendarQuery, AvailabilityCalendarQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<AvailabilityCalendarQuery, AvailabilityCalendarQueryVariables>(
    AvailabilityCalendarDocument,
    baseOptions,
  );
}
export type AvailabilityCalendarQueryHookResult = ReturnType<typeof useAvailabilityCalendarQuery>;
export type AvailabilityCalendarLazyQueryHookResult = ReturnType<typeof useAvailabilityCalendarLazyQuery>;
export type AvailabilityCalendarQueryResult = ApolloReactCommon.QueryResult<AvailabilityCalendarQuery, AvailabilityCalendarQueryVariables>;
export const BookingAuthMethodDocument = gql`
  query BookingAuthMethod($bookingId: ID!) {
    authMethod: bookingAuthMethod(bookingId: $bookingId)
  }
`;

/**
 * __useBookingAuthMethodQuery__
 *
 * To run a query within a React component, call `useBookingAuthMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingAuthMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingAuthMethodQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useBookingAuthMethodQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<BookingAuthMethodQuery, BookingAuthMethodQueryVariables>,
) {
  return ApolloReactHooks.useQuery<BookingAuthMethodQuery, BookingAuthMethodQueryVariables>(BookingAuthMethodDocument, baseOptions);
}
export function useBookingAuthMethodLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BookingAuthMethodQuery, BookingAuthMethodQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<BookingAuthMethodQuery, BookingAuthMethodQueryVariables>(BookingAuthMethodDocument, baseOptions);
}
export type BookingAuthMethodQueryHookResult = ReturnType<typeof useBookingAuthMethodQuery>;
export type BookingAuthMethodLazyQueryHookResult = ReturnType<typeof useBookingAuthMethodLazyQuery>;
export type BookingAuthMethodQueryResult = ApolloReactCommon.QueryResult<BookingAuthMethodQuery, BookingAuthMethodQueryVariables>;
export const BookingDetailsDocument = gql`
  query BookingDetails($bookingId: ID!) {
    booking(bookingId: $bookingId) {
      id
      createdAt
      state
      reference
      channel
      nights
      summaryText
      flags {
        isFinalising
        isBooked
        isBlocked
        isCancelled
        isChangeInProgress
        isRateable
        isCancelable
        isCancelableInApp
        isCancelableByPhone
        isDateAmendableInApp
        isChangeDatesRequestEnabled
        isCreditCardExpired
        hasPendingScheduledPayment
        hasAppleWalletPass
        requiresPaymentMethodUpdate
      }
      cancellationRefund {
        totals {
          amount
          currency
        }
        penalty {
          amount
          currency
        }
        breakdown {
          ...paymentMethodBreakdownFields
        }
      }
      paidBeforeCancellation {
        totals {
          amount
          currency
        }
        breakdown {
          ...paymentMethodBreakdownFields
        }
      }
      payableAtProperty {
        total {
          amount
          currency
        }
        breakdown {
          charge {
            amount
            currency
          }
          description
        }
      }
      links {
        manage(absolute: false)
        rebook(absolute: true)
        updatePaymentMethod(absolute: false)
        print(absolute: false)
        googleMaps
        downloadInvoice
        downloadAppleWalletPass
      }
      travelArranger {
        email
        phone
        businessRegistrationNumber
      }
      reservation {
        checkIn
        checkOut
        checkInDateTime
        checkOutDateTime
        specialRequests
        formattedCheckIn
        formattedCheckOut
        isBeforeCheckInDay
        isAfterCheckOut
        adults
        children
        infants
        qffEarnNumber
        pointsClubTier
        totalQffPointsEarned
        totalQffPointsAwarded
        totalQbrPoints
        bedGroupDescription
        roomType {
          name
          description
        }
        offer {
          name
          type
          description
          inclusions {
            name
          }
        }
        leadGuest {
          name {
            title
            given
            family
          }
          qffNumber
        }
        property {
          id
          name
          email
          phone
          rating
          ratingType
          formattedAddress
          formattedAddressFull
          description
          checkInInstructions
          roomInformation
          knowBeforeYouGoDescription
          mandatoryFeesDescription
          checkInAfter
          checkOutBefore
        }
        cancellationPolicy {
          description
          activeCancellationWindow {
            isFullyRefundable
            isNonRefundable
            isPartiallyRefundable
            endTime
          }
          cancellationWindows {
            cancellationType
            startTime
            endTime
            isFullyRefundable
            isPartiallyRefundable
            isNonRefundable
          }
        }
      }
      mediumImage: image(size: MEDIUM) {
        src
        alt
      }
      largeImage: image(size: LARGE) {
        src
        alt
      }
      transactions {
        type
        reason
        createdAt
        chargeBreakdown {
          creditCard {
            total
            paymentMethod {
              ...creditCardPaymentMethodFields
            }
          }
          points {
            total
            paymentMethod {
              ...pointsPaymentMethodFields
            }
          }
          voucher {
            total
            paymentMethod {
              ...voucherPaymentMethodFields
            }
          }
          creditNote {
            total
            paymentMethod {
              ...creditNotePaymentMethodFields
            }
          }
          qantasGroupCreditVoucher {
            total
            paymentMethod {
              ...qantasGroupCreditVoucherPaymentMethodFields
            }
          }
        }
      }
      paymentSchedule {
        ...scheduledPaymentFragment
      }
      payableAtBooking {
        amount
        currency
      }
      payableTotals {
        amount
        currency
      }
    }
  }
  ${PaymentMethodBreakdownFieldsFragmentDoc}
  ${CreditCardPaymentMethodFieldsFragmentDoc}
  ${PointsPaymentMethodFieldsFragmentDoc}
  ${VoucherPaymentMethodFieldsFragmentDoc}
  ${CreditNotePaymentMethodFieldsFragmentDoc}
  ${QantasGroupCreditVoucherPaymentMethodFieldsFragmentDoc}
  ${ScheduledPaymentFragmentFragmentDoc}
`;

/**
 * __useBookingDetailsQuery__
 *
 * To run a query within a React component, call `useBookingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingDetailsQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useBookingDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BookingDetailsQuery, BookingDetailsQueryVariables>) {
  return ApolloReactHooks.useQuery<BookingDetailsQuery, BookingDetailsQueryVariables>(BookingDetailsDocument, baseOptions);
}
export function useBookingDetailsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BookingDetailsQuery, BookingDetailsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<BookingDetailsQuery, BookingDetailsQueryVariables>(BookingDetailsDocument, baseOptions);
}
export type BookingDetailsQueryHookResult = ReturnType<typeof useBookingDetailsQuery>;
export type BookingDetailsLazyQueryHookResult = ReturnType<typeof useBookingDetailsLazyQuery>;
export type BookingDetailsQueryResult = ApolloReactCommon.QueryResult<BookingDetailsQuery, BookingDetailsQueryVariables>;
export const BookingListDocument = gql`
  query BookingList($accountId: String!, $limit: Int!, $offset: Int!, $filter: BookingListFilter) {
    bookingList(accountId: $accountId, limit: $limit, offset: $offset, filter: $filter) {
      hasMore
      bookings {
        id
        reference
        nights
        payableTotals {
          amount
          currency
        }
        flags {
          isBooked
          isBlocked
          isCancelled
          isChangeInProgress
          isRateable
          isCreditCardExpired
          isFinalising
          hasPendingScheduledPayment
          requiresPaymentMethodUpdate
        }
        image(size: MEDIUM) {
          src
          alt
        }
        links {
          manage(absolute: false)
          print(absolute: false)
          rebook(absolute: true)
          updatePaymentMethod(absolute: false)
        }
        reservation {
          totalGuests
          adults
          children
          infants
          formattedCheckIn
          formattedCheckOut
          isAfterCheckOut
          checkIn
          checkOut
          roomType {
            name
          }
          property {
            id
            name
            formattedAddress
            address {
              suburb
            }
          }
          cancellationPolicy {
            activeCancellationWindow {
              cancellationType
              endTime
              startTime
              isFullyRefundable
              isNonRefundable
            }
          }
        }
        paymentSchedule {
          ...scheduledPaymentFragment
        }
      }
    }
  }
  ${ScheduledPaymentFragmentFragmentDoc}
`;

/**
 * __useBookingListQuery__
 *
 * To run a query within a React component, call `useBookingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingListQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBookingListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BookingListQuery, BookingListQueryVariables>) {
  return ApolloReactHooks.useQuery<BookingListQuery, BookingListQueryVariables>(BookingListDocument, baseOptions);
}
export function useBookingListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BookingListQuery, BookingListQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<BookingListQuery, BookingListQueryVariables>(BookingListDocument, baseOptions);
}
export type BookingListQueryHookResult = ReturnType<typeof useBookingListQuery>;
export type BookingListLazyQueryHookResult = ReturnType<typeof useBookingListLazyQuery>;
export type BookingListQueryResult = ApolloReactCommon.QueryResult<BookingListQuery, BookingListQueryVariables>;
export const GetCancellationDocument = gql`
  query GetCancellation($bookingId: ID!, $cancellationId: ID!) {
    cancellation(bookingId: $bookingId, cancellationId: $cancellationId) {
      ...cancellationFragment
    }
  }
  ${CancellationFragmentFragmentDoc}
`;

/**
 * __useGetCancellationQuery__
 *
 * To run a query within a React component, call `useGetCancellationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCancellationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCancellationQuery({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      cancellationId: // value for 'cancellationId'
 *   },
 * });
 */
export function useGetCancellationQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetCancellationQuery, GetCancellationQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetCancellationQuery, GetCancellationQueryVariables>(GetCancellationDocument, baseOptions);
}
export function useGetCancellationLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCancellationQuery, GetCancellationQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetCancellationQuery, GetCancellationQueryVariables>(GetCancellationDocument, baseOptions);
}
export type GetCancellationQueryHookResult = ReturnType<typeof useGetCancellationQuery>;
export type GetCancellationLazyQueryHookResult = ReturnType<typeof useGetCancellationLazyQuery>;
export type GetCancellationQueryResult = ApolloReactCommon.QueryResult<GetCancellationQuery, GetCancellationQueryVariables>;
export const CreateCancellationDocument = gql`
  mutation CreateCancellation($bookingId: ID!) {
    createCancellation(bookingId: $bookingId) {
      ...cancellationFragment
    }
  }
  ${CancellationFragmentFragmentDoc}
`;
export type CreateCancellationMutationFn = ApolloReactCommon.MutationFunction<
  CreateCancellationMutation,
  CreateCancellationMutationVariables
>;

/**
 * __useCreateCancellationMutation__
 *
 * To run a mutation, you first call `useCreateCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCancellationMutation, { data, loading, error }] = useCreateCancellationMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *   },
 * });
 */
export function useCreateCancellationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCancellationMutation, CreateCancellationMutationVariables>,
) {
  return ApolloReactHooks.useMutation<CreateCancellationMutation, CreateCancellationMutationVariables>(
    CreateCancellationDocument,
    baseOptions,
  );
}
export type CreateCancellationMutationHookResult = ReturnType<typeof useCreateCancellationMutation>;
export type CreateCancellationMutationResult = ApolloReactCommon.MutationResult<CreateCancellationMutation>;
export type CreateCancellationMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CreateCancellationMutation,
  CreateCancellationMutationVariables
>;
export const AcceptCancellationDocument = gql`
  mutation AcceptCancellation($bookingId: ID!, $cancellationId: ID!, $input: AcceptCancellationInput!) {
    acceptCancellation(bookingId: $bookingId, cancellationId: $cancellationId, input: $input) {
      ...cancellationFragment
    }
  }
  ${CancellationFragmentFragmentDoc}
`;
export type AcceptCancellationMutationFn = ApolloReactCommon.MutationFunction<
  AcceptCancellationMutation,
  AcceptCancellationMutationVariables
>;

/**
 * __useAcceptCancellationMutation__
 *
 * To run a mutation, you first call `useAcceptCancellationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptCancellationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptCancellationMutation, { data, loading, error }] = useAcceptCancellationMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      cancellationId: // value for 'cancellationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptCancellationMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptCancellationMutation, AcceptCancellationMutationVariables>,
) {
  return ApolloReactHooks.useMutation<AcceptCancellationMutation, AcceptCancellationMutationVariables>(
    AcceptCancellationDocument,
    baseOptions,
  );
}
export type AcceptCancellationMutationHookResult = ReturnType<typeof useAcceptCancellationMutation>;
export type AcceptCancellationMutationResult = ApolloReactCommon.MutationResult<AcceptCancellationMutation>;
export type AcceptCancellationMutationOptions = ApolloReactCommon.BaseMutationOptions<
  AcceptCancellationMutation,
  AcceptCancellationMutationVariables
>;
export const MemberDocument = gql`
  query Member($memberId: String!) {
    member(memberId: $memberId) {
      memberId
      title
      firstName
      lastName
      pointsBalance
      membershipTier
    }
  }
`;

/**
 * __useMemberQuery__
 *
 * To run a query within a React component, call `useMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useMemberQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MemberQuery, MemberQueryVariables>) {
  return ApolloReactHooks.useQuery<MemberQuery, MemberQueryVariables>(MemberDocument, baseOptions);
}
export function useMemberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MemberQuery, MemberQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<MemberQuery, MemberQueryVariables>(MemberDocument, baseOptions);
}
export type MemberQueryHookResult = ReturnType<typeof useMemberQuery>;
export type MemberLazyQueryHookResult = ReturnType<typeof useMemberLazyQuery>;
export type MemberQueryResult = ApolloReactCommon.QueryResult<MemberQuery, MemberQueryVariables>;
